//@ts-nocheck
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
  PDFViewer,
  PDFDownloadLink,
} from "@react-pdf/renderer";
import { PiLinkBold } from "react-icons/pi";
import iranSansLight from "../../assets/fonts/iran-sans-400.ttf";
import iranSansBold from "../../assets/fonts/iran-sans-700.ttf";
import rokhLight from "../../assets/fonts/rokh-Medium.ttf";
import rokhBold from "../../assets/fonts/rokh-ExtraBold.ttf";
import BgShape_1 from "../../assets/icons/bg-shape_1.png";
import BgShape_2 from "../../assets/icons/bg-shape_2.png";
import PdfIntro from "./PdfIntro";
import PdfTestIntro from "./PdfTestIntro";
import PdfTestPanels from "./PdfTestPanels";
import PdfFactors from "./PdfFactors";
import PdfHealthChecklist from "./PdfHealthChecklist";
import PdfRecommendation from "./PdfRecommendation";
import PdfBiologicalAge from "./PdfBiologicalAge";

const componentStyles = StyleSheet.create({
  pdfWrapper: {
    width: "500px",
    height: "500px",
    position: "relative",
    border: "1px solid #000",
  },
  pdfContainer: {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    zIndex: 10,
    padding: "35px 0px 40px",
  },
});

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    fontFamily: "iran-sans",
    height: "100vh",
    color: "#0D426D",
  },
  pageTitle: {
    marginRight: "20px",
    marginTop: "0",
    fontSize: "18px",
    fontWeight: 900,
    textAlign: "right",
  },
});

Font.register({
  family: "iran-sans",
  fonts: [
    { src: iranSansLight, fontWeight: 400 },
    { src: iranSansBold, fontWeight: 700 },
  ],
});
Font.register({
  family: "rokh",
  fonts: [
    { src: rokhLight, fontWeight: 700 },
    { src: rokhBold, fontWeight: 900 },
  ],
});

const PdfExport = ({ testInfo, testResults }: any) => {
  const is_pro = testInfo.is_pro_analysis;

  const ExportPdfFile = () => {
    return (
      <Document>
        <Page
          size="A4"
          orientation="landscape"
          style={styles.page}
          break={false}
          wrap={false}
        >
          <PdfIntro />
          <PdfTestIntro testInfo={testInfo} />
          <PdfTestPanels testResults={testResults} is_pro={is_pro} />
          <PdfFactors testResults={testResults} />
          <PdfHealthChecklist testResults={testResults} is_pro={is_pro} />
          <PdfRecommendation testResults={testResults} is_pro={is_pro} />
          <PdfBiologicalAge
            testInfo={testInfo}
            testResults={testResults}
            is_pro={is_pro}
          />
          <PdfIntro />
        </Page>
      </Document>
    );
  };

  return (
    <div className="bg-pr_purple relative p-6 rounded-xl overflow-hidden">
      <img
        src={BgShape_2}
        className="absolute left-0 top-0 w-full opacity-[0.04] z-0"
      />

      <div className="flex items-center justify-between relative z-[1]">
        <h6 className="font-rokh font-[900] mt-2 text-xl">دانلود نتیجه</h6>
        <div className="bg-white rounded-full p-1 w-9 h-9 flex items-center justify-center">
          <PiLinkBold size={18} />
        </div>
      </div>
      <img src={BgShape_1} className="w-4/12 mx-auto my-10" />
      <button className="w-full bg-pr_purple_dark text-white rounded-lg p-2 z-[1] relative">
        <PDFDownloadLink document={<ExportPdfFile />} fileName="بادی‌بان.pdf">
          {({ loading }) =>
            loading ? (
              <strong className="font-rokh font-[700]">
                در حال آماده‌سازی...
              </strong>
            ) : (
              <strong className="font-rokh font-[700]"> دانلود </strong>
            )
          }
        </PDFDownloadLink>
      </button>
    </div>
  );
};

export default PdfExport;
